<div class="multipoint-modal-error-installtion__container-title">
  <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.ERROR_INSTALLATION' | i18nextEager }}</h2>
</div>
<div class="multipoint-modal-error-installtion__container">
  <ng-container *ngFor="let item of dataDialog">
    <div *ngIf="!item.registeredCRM" class="multipoint-modal-error-installtion__container-items">
      <span class="multipoint-modal-error-installtion__circle"></span>
      <p>
        <strong>{{ item.name }}: </strong>{{ item.descriptionErrorRegisteredCRM }}
      </p>
    </div>
  </ng-container>
</div>
<div class="multipoint-modal-error-installtion__buttons">
  <button class="secondary" (click)="closeModal('close')">{{ 'COMMONS.CANCEL' | i18nextEager }}</button>
  <button class="primary" (click)="closeModal('continue')">
    {{ 'COMMONS.CONTINUE' | i18nextEager }}
  </button>
</div>
